import { replaceLinksForDocument, replaceLinksForSite } from './assignment_compute';
const assignmentsPath = (entityId, studyId, environmentId) => `/v1/entities/${entityId}/studies/${studyId}/environments/${environmentId}/environment-site-consent-assignments`;
/**
 * Translates UI-side {@link Assignment}s to MOM `(siteId, templateKey)` rows, dedupes,
 * and PUTs the full set for the environment (PUT semantics — full replace).
 */
async function putAssignments(momClient, entityId, studyId, environmentId, assignments, consentFiles) {
    const docIdToKey = new Map();
    for (const file of consentFiles) {
        docIdToKey.set(file.id, file.templateKey);
    }
    const seen = new Set();
    const body = [];
    for (const a of assignments) {
        const templateKey = docIdToKey.get(a.consentDocumentId);
        if (!templateKey) {
            continue;
        }
        const dedupeKey = `${a.environmentSiteId}:${templateKey}`;
        if (seen.has(dedupeKey)) {
            continue;
        }
        seen.add(dedupeKey);
        body.push({ environmentSiteId: a.environmentSiteId, consentTemplateKey: templateKey });
    }
    await momClient.put(assignmentsPath(entityId, studyId, environmentId), { assignments: body });
}
export async function setAssignmentsForDocument(momClient, entityId, studyId, environmentId, assignments, documentId, selectedEnvironmentSiteIds, environmentSites, consentFiles) {
    const nextAssignments = replaceLinksForDocument(assignments, documentId, selectedEnvironmentSiteIds, environmentSites.map((site) => site.id));
    await putAssignments(momClient, entityId, studyId, environmentId, nextAssignments, consentFiles);
    return nextAssignments;
}
export async function setAssignmentsForSite(momClient, entityId, studyId, environmentId, assignments, environmentSiteId, selectedConsentDocumentIds, consentDocumentIdsInScope, consentFiles) {
    const nextAssignments = replaceLinksForSite(assignments, environmentSiteId, selectedConsentDocumentIds, consentDocumentIdsInScope);
    await putAssignments(momClient, entityId, studyId, environmentId, nextAssignments, consentFiles);
    return nextAssignments;
}
/**
 * Replaces every (site, document) assignment within the scoped environment via MOM.
 */
export async function replaceAllAssignments(momClient, entityId, studyId, environmentId, assignments, consentFiles) {
    await putAssignments(momClient, entityId, studyId, environmentId, assignments, consentFiles);
    return assignments;
}
